export default "__VITE_ASSET__$VBuIyzv__"